module.exports = __webpack_public_path__ + "img/21.8cffd065.jpg";